import React from 'react';
import proptypes from 'prop-types';

import { Typography } from '@one-thd/sui-atomic-components';

import { usePipCalculatorData } from '../../../hooks/usePipCalculatorData';
import { DEFAULT_CALC_CLASSES, DEFAULT_DESCRIPTION, FIXED_WIDTH } from '../../../constants';
import { CalculateByDimensions } from '../../CalculateByDimensions';
import { CalculatorFooter } from '../../CalculatorFooter';
import { CalculatorInputSections } from '../../CalculatorInputSections';
import { CalculatorProvider } from '../CalculatorProvider';
import { samDataModel } from '../../dataModel';
import { EstimatedTotal } from './EstimatedTotal/EstimatedTotal';

const { string } = proptypes;

export const SAMCalculator = ({ itemId }) => {
  const {
    shouldDisplay,
    info,
    pipCalculatorProps,
    pricing,
    taxonomy
  } = usePipCalculatorData({ itemId, isInstalledCarpet: true });

  if (!shouldDisplay) {
    return null;
  }

  const { unitsPerCase } = pricing?.alternate?.unit || {};
  const dimensionNames = ['Length', 'Width'];
  const { calcProps: { calculatorType } } = pipCalculatorProps;

  return (
    <div data-component="SAMCalculator">
      <CalculatorProvider
        calculatorType={calculatorType || FIXED_WIDTH}
        info={info}
        lineItemName="Area"
        taxonomy={taxonomy}
        unitsPerCase={unitsPerCase}
      >
        <div className={DEFAULT_CALC_CLASSES}>
          <Typography>{DEFAULT_DESCRIPTION}</Typography>
          <CalculateByDimensions dimensionNames={dimensionNames} />
          <CalculatorInputSections dimensionNames={dimensionNames} />
          <CalculatorFooter />
        </div>
        <EstimatedTotal sqFtPrice={pricing?.alternate?.unit?.value} />
      </CalculatorProvider>
    </div>
  );
};

SAMCalculator.displayName = 'SAMCalculator';

SAMCalculator.dataModel = samDataModel;

SAMCalculator.propTypes = {
  itemId: string.isRequired
};